import { paddingConversions } from './conversionTables/paddingConversions'
import { marginConversions } from './conversionTables/marginConversions'

// Convert our Craft px spacing classes to Tailwind rem classes
const _spacingConversion = (classString: string) => {
  // Return the original empty string if this didn't actually do anything
  if (!classString.length) {
    return classString
  }
  // Split the class string to an array and loop through it with reduce, to convert and rebuild the class string
  const classes = classString.split(' ')

  return classes.reduce((acc: string, curr: string) => {
    let convertedClass = curr
    // Typescript doesn't like that we aren't explicitly defining all the types
    // But that's a giant waste of time for the padding/margin conversion objects, so we're just going to ignore this
    // @ts-ignore
    if (paddingConversions[curr]) {
      // @ts-ignore
      convertedClass = paddingConversions[curr]
      // @ts-ignore
    } else if (marginConversions[curr]) {
      // @ts-ignore
      convertedClass = marginConversions[curr]
    }
    return acc === '' ? convertedClass : acc.concat(' ', convertedClass)
  }, '')
}

export const _cssClassMerge = (cssClasses: { className: string }[]) => {
  // If we somehow hit this function without an actual array of classes, just return an empty string
  if (!cssClasses?.length) {
    return ''
  }
  // Otherwise, merge all the strings into one
  return cssClasses.reduce(
    (acc: string, curr: { className: string }) =>
      acc === '' ? curr.className : acc.concat(' ', curr.className),
    ''
  )
}

export const createCssString = (cssClasses: { className: string }[]) =>
  _spacingConversion(_cssClassMerge(cssClasses))
